import { FC, useEffect, useState } from 'react'
import { Flex, Button, Center, Heading, Text, VStack, Divider } from '@chakra-ui/react'

import MetadataFieldCard from './components/MetadataFieldCard'

type Props = {
  metadatas?: any
  hideHeader?: boolean
  label?: string
  maxFields?: number
  defaultFields?: number[]
  setFieldLabel: (index: number) => string
  setFieldName: (index: number) => string
  setFieldDataTypeName: (index: number) => string
  register: any
  setValue?: any
  watch?: any
}

const DynamicMetadatas: FC<Props> = ({
  metadatas,
  hideHeader = false,
  register,
  setValue,
  watch,
  label = 'Campos complementares',
  defaultFields = [0],
  maxFields = 7,
  setFieldLabel,
  setFieldName,
  setFieldDataTypeName,
}) => {
  const [fields, setFields] = useState<number[]>(defaultFields)

  function handleAddCustomField() {
    const isMaxAccepted = maxFields <= 7
    if (isMaxAccepted) setFields([...fields, fields.length])
  }

  function getComplementedFieldsByMetadata() {
    const fieldsWithValue = Object.entries(metadatas).filter(([key, value]) => {
      if (key.includes('info') && key.includes('label')) {
        const keyIndex = Number(key.split('_')[1])
        return keyIndex <= maxFields && value !== null
      }
      return false
    })

    if (fieldsWithValue.length === 0) return [0]

    const [lastInfoLabel] = fieldsWithValue[fieldsWithValue.length - 1]

    const lastInfoLabelIndex = Number(lastInfoLabel.split('_')[1])

    const maxFieldToShow = Array.from({ length: lastInfoLabelIndex }, (_, index) => index)

    return maxFieldToShow.length > 0 ? maxFieldToShow : [0]
  }

  useEffect(() => {
    if (metadatas) return setFields(getComplementedFieldsByMetadata())
    return setFields(defaultFields)
  }, [metadatas])

  return (
    <Flex direction="column" width="100%" gap={4}>
      {!hideHeader && (
        <>
          <Divider />
          <Heading>{label}</Heading>
        </>
      )}

      {fields.map((index) => (
        <MetadataFieldCard
          key={index}
          label={setFieldLabel(index + 1)}
          name={setFieldName(index + 1)}
          dataType={setFieldDataTypeName(index + 1)}
          register={register}
          setValue={setValue}
          watch={watch}
        />
      ))}

      <Center>
        <VStack mb={4}>
          <Button isDisabled={fields.length === maxFields} variant="outline" onClick={handleAddCustomField}>
            Adicionar {label.toLowerCase()}
          </Button>
          {fields.length === maxFields && <Text>Número máximo de informações excedido</Text>}
        </VStack>
      </Center>
    </Flex>
  )
}

export default DynamicMetadatas
